import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Logger } from '../../../../../../../src/app/core/logger/logger.service';
import { FlightService } from '../../../flight.service';
const log = new Logger('FlightSearchComponent');

@Component({
    selector: 'app-trip-info',
    templateUrl: './trip-info.component.html',
    styleUrls: ['./trip-info.component.scss']
})
export class TripInfoComponent implements OnInit {
    public arrow_right: string = "assets/images/right_arrow.png";
    airline_logo: string = '';
    flightInfo: any;
    deptDate: any;
    returnDate: any = '';

    constructor(
        private flightService: FlightService,
        private cdr: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.airline_logo = this.flightService.airline_logo;
        this.flightInfo = this.data.data;
        this.deptDate = new Date(this.flightInfo.departureDate)
        this.deptDate = this.formatDate(this.deptDate)
        if (this.flightInfo.returnDate && this.flightInfo.returnDate != '') {
            this.returnDate = new Date(this.flightInfo.returnDate)
            this.returnDate = this.formatDate(this.returnDate)
        }
        this.cdr.detectChanges()
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    getCity(cityName) {
        let city = String(cityName).split(',')[0];
        return city;
    }

}
